<!--
 * @Descripttion:数字翻牌器
 * 兼容 config.prefix与 config.suffix FixfontSize(前后缀字号) 保留因为很多地方都在使用
 * @Author: zhanghang
 * @Date: 2022-08-02 11:17:18
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-09 16:49:12
-->

<template>
  <div
    class="data-view-item-wrap ds-control data-view-scroll-digital data-view-no-padding"
    :style="controlStyle"
    @click="clickItem"
    v-loading="dataLoad"
    :element-loading-text="loadingText"
    :element-loading-spinner="loadingSpinner"
    :element-loading-background="loadingBackground"
    :ref="componentRef"
  >
    <slot
      name="default"
      :prefix="config.prefix"
      :data="displayValue"
      :suffix="config.suffix"
      :row="nowData"
    >
      <div
        v-if="isTotalDigital"
        class="split-digital-item split-digital-item-total"
        :style="splitDigitalItemStyle"
      >
        <slot
          name="prefix"
          :info="getPrefixStyle"
          :row="nowData"
          :config="config"
          v-if="(isPrefix || config.prefix) && nowData"
        >
          <template v-if="isPrefix">
            <span :style="getPrefixStyle">
              <template v-if="getPrefixStyle.other.showType === 'icon'">
                <i
                  :class="`common-icon iconfont icon-${getPrefixStyle.other.icon}`"
                ></i>
              </template>
              <template
                v-else-if="
                  getPrefixStyle.other.showType === 'img' &&
                    getPrefixStyle.other.imgObj
                "
              >
                <img
                  class="common-img"
                  :src="handleImgSrcStr(getPrefixStyle.other.imgObj.src)"
                  :width="getPrefixStyle.other.imgObj.width"
                  :height="getPrefixStyle.other.imgObj.height"
                />
              </template>
              <template v-else>
                {{
                  handleExpressionContent(getPrefixStyle.other.content, nowData)
                }}
              </template>
            </span>
          </template>
          <span :style="fontFixStyle" v-else-if="config.prefix">
            {{ config.prefix }}
          </span>
        </slot>

        &nbsp;{{ displayValue }}&nbsp;
        <slot
          name="suffix"
          :info="getSuffixStyle"
          :row="nowData"
          :config="config"
          v-if="(isSuffix || config.suffix) && nowData"
        >
          <template v-if="isSuffix">
            <span :style="getSuffixStyle">
              <template v-if="getSuffixStyle.other.showType === 'icon'">
                <i
                  :class="`common-icon iconfont icon-${getSuffixStyle.other.icon}`"
                ></i>
              </template>
              <template
                v-else-if="
                  getSuffixStyle.other.showType === 'img' &&
                    getSuffixStyle.other.imgObj
                "
              >
                <img
                  class="common-img"
                  :src="handleImgSrcStr(getSuffixStyle.other.imgObj.src)"
                  :width="getSuffixStyle.other.imgObj.width"
                  :height="getSuffixStyle.other.imgObj.height"
                />
              </template>
              <template v-else>
                {{
                  handleExpressionContent(getSuffixStyle.other.content, nowData)
                }}
              </template>
            </span>
          </template>
          <span :style="fontFixStyle" v-else-if="config.suffix">
            {{ config.suffix }}
          </span>
        </slot>
      </div>
      <div class="split-digital" :style="fontStyle" v-else>
        <slot
          name="prefix"
          :info="getPrefixStyle"
          :row="nowData"
          :config="config"
          v-if="(isPrefix || config.prefix) && nowData"
        >
          <span :style="getPrefixStyle" v-if="isPrefix">
            <template v-if="getPrefixStyle.other.showType === 'icon'">
              <i
                :class="`common-icon iconfont icon-${getPrefixStyle.other.icon}`"
              ></i>
            </template>
            <template
              v-else-if="
                getPrefixStyle.other.showType === 'img' &&
                  getPrefixStyle.other.imgObj
              "
            >
              <img
                class="common-img"
                :src="handleImgSrcStr(getPrefixStyle.other.imgObj.src)"
                :width="getPrefixStyle.other.imgObj.width"
                :height="getPrefixStyle.other.imgObj.height"
              />
            </template>
            <template v-else>
              {{
                handleExpressionContent(getPrefixStyle.other.content, nowData)
              }}
            </template>
          </span>
          <span :style="fontFixStyle" v-else-if="config.prefix">
            {{ config.prefix }}
          </span>
        </slot>
        <div
          :style="splitDigitalItemStyle"
          class="split-digital-item"
          :class="{
            'split-digital-symbol': !isNumber(item),
          }"
          v-for="(item, index) in splitValue"
          :key="index"
        >
          {{ item }}
        </div>
        <slot
          name="suffix"
          :info="getSuffixStyle"
          :row="nowData"
          :config="config"
          v-if="(isSuffix || config.suffix) && nowData"
        >
          <template v-if="isSuffix">
            <span :style="getSuffixStyle">
              <template v-if="getSuffixStyle.other.showType === 'icon'">
                <i
                  :class="`common-icon iconfont icon-${getSuffixStyle.other.icon}`"
                ></i>
              </template>
              <template
                v-else-if="
                  getSuffixStyle.other.showType === 'img' &&
                    getSuffixStyle.other.imgObj
                "
              >
                <img
                  class="common-img"
                  :src="handleImgSrcStr(getSuffixStyle.other.imgObj.src)"
                  :width="getSuffixStyle.other.imgObj.width"
                  :height="getSuffixStyle.other.imgObj.height"
                />
              </template>
              <template v-else>
                {{
                  handleExpressionContent(getSuffixStyle.other.content, nowData)
                }}
              </template>
            </span>
          </template>
          <span :style="fontFixStyle" v-else-if="config.suffix">
            {{ config.suffix }}
          </span>
        </slot>
      </div>
    </slot>
  </div>
</template>
<script>
import { createOneRule } from "_dataview/output/config/prefixSuffixRuleConfig";
import {
  extendsAttrs,
  createWholeConfig,
} from "_dataview/output/config/scrollDigital";
import {
  requestAnimationFrame,
  cancelAnimationFrame,
} from "./requestAnimationFrame.js";

const staticDataKeyDic = {
  startVal: "起始值",
  endVal: "结束值",
};
const staticData = {
  startVal: "0",
  endVal: "2022",
};
export default dsf.component({
  name: "DsfDataViewScrollDigital",
  ctrlCaption: "数字翻牌器",
  mixins: [
    $mixins.dataView,
    $mixins.dataAnalysis,
    $mixins.prefixSuffixRuleSetting,
  ],
  props: {
    wholeConfig: {
      type: Object,
      default: () => ({
        ...createWholeConfig(),
      }),
    },
    staticData: {
      type: Object,
      default: () => staticData,
    },
    config: {
      type: Object,
      default() {
        return {
          duration: 3000,
          autoplay: true,
          prefix: "",
          suffix: "",
          useEasing: true,
          easingFn: function (t, b, c, d) {
            return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b;
          },
        };
      },
    },
    unitTransform: {
      type: String,
      default: "",
    },
    isPrefix: {
      type: Boolean,
      default: false,
    },
    isShowZero: {
      type: Boolean,
      default: true,
    },
    prefixRuleConfig: {
      type: Object,
      default: () => ({
        defaultForm: createOneRule(),
        ruleList: [],
      }),
    },
    prefixRuleShowType: {
      type: String,
      default: "content",
    },
    prefixRuleIcon: {
      type: String,
      default: "",
    },
    prefixRuleImgConfig: {
      type: Object,
      default: () => ({
        src: "",
        width: "20",
        height: "auto",
      }),
    },
    prefixRuleContent: {
      type: String,
      default: "",
    },
    isSuffix: {
      type: Boolean,
      default: false,
    },
    suffixRuleConfig: {
      type: Object,
      default: () => ({
        defaultForm: createOneRule(),
        ruleList: [],
      }),
    },
    suffixRuleShowType: {
      type: String,
      default: "content",
    },
    suffixRuleIcon: {
      type: String,
      default: "",
    },
    suffixRuleImgConfig: {
      type: Object,
      default: () => ({
        src: "",
        width: "20",
        height: "auto",
      }),
    },
    suffixRuleContent: {
      type: String,
      default: "",
    },
    decimals: {
      type: [String, Number],
      default: 0,
    },
    decimal: {
      type: String,
      default: ".",
    },
    separator: {
      type: String,
      default: "",
    },
    singleBackgroundConfig: {
      type: Object,
      default: () => ({}),
    },
    fontSize: {
      type: [String, Number],
      default: 32,
    },
    isFontBold: {
      type: Boolean,
      default: false,
    },
    FixfontSize: {
      type: [String, Number],
      default: 32,
    },
    isTotalDigital: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: "center",
    },
    fontMargin: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    fontPadding: {
      type: Array,
      default: () => [5, 10, 5, 10],
    },
    digitalFont: {
      type: Boolean,
      default: false,
    },
    fontBgColor: {
      type: [String, Object],
      default: null,
    },
    color: {
      type: String,
      default: "#FFFFFF",
    },
    height: {
      type: String,
      default: "auto",
    },
    excelData: {
      type: Array,
      default: () => {
        let rows = dsf.dataview.utils.dataAnalysisTransFormExcel(
          [staticData],
          staticDataKeyDic
        );
        return [
          {
            rows,
          },
        ];
      },
    },
    mapRelations: {
      type: Array,
      default() {
        return [
          {
            text: "起始值",
            value: "startVal",
            map: "start",
            hideDigit: true,
          },
          {
            text: "结束值",
            value: "endVal",
            map: "end",
            hideDigit: true,
          },
        ];
      },
    },
  },
  data() {
    return {
      nowData: null,
      otherEvents: ["刷新", "还原数据", "显示", "隐藏", "替换数据"],
      localStartVal: 0,
      displayValue: this.formatNumber(0),
      componentRef: "data-view-scroll-digital",
      startVal: 0,
      endVal: 0,
      printVal: null,
      paused: false,
      localDuration: this.config.duration,
      startTime: null,
      timestamp: null,
      remaining: null,
      rAF: null,
      isFinish: true,
    };
  },
  computed: {
    fontFixStyle() {
      return {
        fontSize: this.transPX(this.FixfontSize),
      };
    },
    countDown() {
      let { startVal, endVal } = this;
      return startVal > endVal;
    },
    splitValue() {
      if (this.unitTransform) {
        return this.transformUnit(
          this.displayValue,
          this.unitTransform,
          false,
          this.decimals
        );
      }
      return (this.displayValue + "").split("");
    },
    fontColor() {
      let color = this.color;
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    transFontBgColor() {
      let color = this.fontBgColor;
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    splitDigitalItemStyle() {
      let {
        align,
        fontColor,
        fontPadding: paddingArray,
        fontMargin: marginArray,
        transFontSize,
        transFontBgColor,
        isFontBold,
        singleBackgroundConfig,
      } = this;
      let backgroundObj =
        this.$colorFormatCoexist(singleBackgroundConfig) || {};
      let padding = this.handleArrPX(paddingArray);
      let margin = this.handleArrPX(marginArray);
      const style = {
        color: fontColor,
        "background-color": transFontBgColor,
        "justify-content": align,
        padding,
        margin,
        fontSize: transFontSize,
        ...backgroundObj,
      };

      if (this.digitalFont) {
        style["fontFamily"] = "DIGIT";
      }
      if (isFontBold) {
        style["font-weight"] = "bold";
      }
      return style;
    },
    getPrefixStyle() {
      let nowData = this.nowData;
      let style =
        this.handlePrefixSuffixStyle(this.prefixRuleConfig, nowData, {
          defaultRuleShowType: this.prefixRuleShowType,
          defaultRuleIcon: this.prefixRuleIcon,
          defaultRuleContent: this.prefixRuleContent,
          defaultRuleImg: {
            ...this.prefixRuleImgConfig,
            ...{ src: this.prefixRuleImgConfig.src?.custom?.image },
          },
        }) || {};
      return style;
    },
    getSuffixStyle() {
      let nowData = this.nowData;
      let style =
        this.handlePrefixSuffixStyle(this.suffixRuleConfig, nowData, {
          defaultRuleShowType: this.suffixRuleShowType,
          defaultRuleIcon: this.suffixRuleIcon,
          defaultRuleContent: this.suffixRuleContent,
          defaultRuleImg: {
            ...this.suffixRuleImgConfig,
            ...{ src: this.suffixRuleImgConfig.src?.custom?.image },
          },
        }) || {};
      return style;
    },
  },
  watch: {
    config: {
      handler(v) {
        this.init();
      },
      deep: true,
    },
    prefixRuleConfig() {
      this.init();
    },
    suffixRuleConfig() {
      this.init();
    },
    staticData: {
      handler(v) {
        this.init();
      },
    },
    decimals() {
      this.init();
    },
    separator() {
      this.init();
    },
    mapRelations: {
      handler(v) {
        this.init();
      },
    },
    wholeConfig: {
      handler(v) {
        extendsAttrs.forEach((key) => {
          this.$emit(`update:${key}`, v[key]);
        });
      },
      deep: true,
    },
  },
  created() {
    this.initWholeConfigProps();
    this.prefixRuleImgConfig.src = this.compatiblePathToObj(
      this.prefixRuleImgConfig.src
    );
    this.suffixRuleImgConfig.src = this.compatiblePathToObj(
      this.suffixRuleImgConfig.src
    );
  },
  mounted() {
    this.newExcelData();
  },
  methods: {
    initWholeConfigProps() {
      let obj = {};
      extendsAttrs.forEach((key) => {
        obj[key] = this[key];
      });
      this.$emit("update:wholeConfig", obj);
    },
    newExcelData() {
      if (!this.excelData.length) {
        let rows = dsf.dataview.utils.dataAnalysisTransFormExcel(
          [staticData],
          staticDataKeyDic
        );
        this.$emit("update:excelData", [
          {
            rows,
          },
        ]);
      }
    },
    dataExcelAnalysis(res) {
      let data = dsf.dataview.utils.dataExcelCommonExcelToArrayObj(
        res,
        (fieldArray) => {
          this.$emit("update:excelMapFieldList", fieldArray);
        }
      );
      // 更新字段
      this.$dataAnalysis(data);
    },
    clickItem() {
      this.loadClickEvents({
        startVal: this.startVal,
        endVal: this.endVal,
      });
    },
    dataAnalysis(data) {
      if (
        (this.dataType === "combineTable" || this.dataType === "datasource") &&
        !this.isDesign
      ) {
        if (!data.length) {
          this.hasData = false;
          return false;
        }
      } else {
        if (Array.isArray(data)) {
          if (!data.length) {
            this.hasData = false;
            return false;
          }
        } else {
          if (!data || data.endVal === undefined) {
            this.hasData = false;
            return false;
          }
        }
      }
      if (eval(this.dymicRules) || this.dataType === "excel") {
        let startKey = this.mapRelations[0].map;
        let endKey = this.mapRelations[1].map;
        if (endKey && Array.isArray(data)) {
          this.nowData = data[0];
          this.startVal = data[0][startKey] || 0;
          this.endVal = data[0][endKey];
        }
      } else {
        if (!data.startVal) {
          data.startVal = 0;
        }
        this.nowData = data;
        let { startVal, endVal } = data;
        this.startVal = startVal;
        this.endVal = endVal;
      }
      if (this.config.autoplay) {
        this.start();
      } else {
        this.displayValue = this.formatNumber(this.endVal);
      }
    },
    changeDataRender(obj) {
      let flag = false;
      if (Array.isArray(obj)) {
        let startVal = obj[0];
        let endVal = obj[1];
        if (startVal && endVal) {
          this.startVal = startVal;
          this.endVal = endVal;
          flag = true;
        } else if (startVal && !endVal) {
          this.startVal = 0;
          this.endVal = startVal;
          flag = true;
        } else {
          flag = false;
        }
      } else if (obj && typeof obj === "object") {
        let startVal = obj.startVal;
        let endVal = obj.endVal;
        if (startVal && endVal) {
          this.startVal = startVal;
          this.endVal = endVal;
          flag = true;
        }
      } else if (!isNaN(obj)) {
        this.startVal = 0;
        this.endVal = obj;
        flag = true;
      }
      if (flag) {
        if (this.config.autoplay) {
          this.start();
        } else {
          this.displayValue = this.formatNumber(this.endVal);
        }
      }
    },
    start() {
      this.isFinish = false;
      this.localStartVal = this.startVal;
      this.startTime = null;
      this.localDuration = this.config.duration;
      this.paused = false;
      this.rAF = requestAnimationFrame(this.count);
    },
    pauseResume() {
      if (this.paused) {
        this.resume();
        this.paused = false;
      } else {
        this.pause();
        this.paused = true;
      }
    },
    pause() {
      cancelAnimationFrame(this.rAF);
    },
    resume() {
      this.startTime = null;
      this.localDuration = +this.remaining;
      this.localStartVal = +this.printVal;
      requestAnimationFrame(this.count);
    },
    reset() {
      this.startTime = null;
      const { startVal } = this;
      cancelAnimationFrame(this.rAF);
      this.displayValue = this.formatNumber(startVal);
    },
    count(timestamp) {
      let { endVal } = this;
      let self = this;
      function _easingFn(t, b, c, d) {
        let nowA = (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b;
        //新增加功能
        if (!self.isShowZero) {
          let decimalLength = self.decimals;
          let nowVal = self.endVal;
          if (isNaN(Number(nowVal))) {
            nowVal = 0;
          }
          nowVal = (parseFloat(nowVal) + "").split(".");
          let nowValDecimalLength = nowVal[1]?.length || 0;
          let min = Math.min(nowValDecimalLength, decimalLength);
          nowA = Number(nowA).toFixed(min);
        }
        return nowA;
      }
      let { useEasing, easingFn = _easingFn } = this.config;
      if (!this.startTime) this.startTime = timestamp;
      this.timestamp = timestamp;
      const progress = timestamp - this.startTime;
      this.remaining = this.localDuration - progress;
      if (useEasing) {
        if (this.countDown) {
          this.printVal =
            this.localStartVal -
            easingFn(
              progress,
              0,
              this.localStartVal - endVal,
              this.localDuration
            );
        } else {
          this.printVal = easingFn(
            progress,
            this.localStartVal,
            endVal - this.localStartVal,
            this.localDuration
          );
        }
      } else {
        if (this.countDown) {
          this.printVal =
            this.localStartVal -
            (this.localStartVal - endVal) * (progress / this.localDuration);
        } else {
          this.printVal =
            this.localStartVal +
            (endVal - this.localStartVal) * (progress / this.localDuration);
        }
      }
      if (this.countDown) {
        this.printVal = this.printVal < endVal ? endVal : this.printVal;
      } else {
        this.printVal = this.printVal > endVal ? endVal : this.printVal;
      }
      if (progress < this.localDuration) {
        this.rAF = requestAnimationFrame(this.count);
      } else {
        this.isFinish = true;
        this.$emit("callback");
      }
      this.displayValue = this.formatNumber(this.printVal);
    },
    isNumber(val) {
      return !isNaN(parseFloat(val));
    },
    formatNumber(num) {
      let { separator, decimals, decimal } = this;

      if (isNaN(Number(num))) {
        num = 0;
      }
      num = Number(num).toFixed(decimals);
      if (!this.isShowZero) {
        if (this.isFinish) {
          num = parseFloat(num);
        }
      }
      num += "";
      const x = num.split(".");
      let x1 = x[0];
      const x2 = x.length > 1 ? decimal + x[1] : "";
      const rgx = /(\d+)(\d{3})/;
      if (separator && !this.isNumber(separator)) {
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + separator + "$2");
        }
      }
      return x1 + x2;
    },
  },
  destroyed() {
    cancelAnimationFrame(this.rAF);
  },
});
</script>
